import React from "react";

const Hero = () => {
  return (
    <section
      id="home"
      className="bg-cover bg-center text-white py-20 px-6 md:px-16 lg:px-32"
      style={{
        backgroundImage: `url('/hero-image.png')`, // Use the image from the public folder
      }}
    >
      <div className="text-center md:text-left relative pt-40 bg-gradient-to-b from-black/50 to-transparent">
        <div className="ml-10">
          <h1 className="text-5xl md:text-7xl font-bold leading-tight mb-6">
            <span className="block text-light-green font-extrabold tracking-wide animate-fade-in">
              Welcome to
            </span>
            <span className="block mt-6 text-primary bg-white font-extrabold tracking-wider animate-slide-up text-6xl md:text-8xl">
              Arancia
            </span>
          </h1>
          <p className="text-lg md:text-xl text-white opacity-90 mb-8">
            Empowering businesses with tailored Odoo solutions for enhanced
            efficiency and growth.
          </p>
          <a
            href="#services"
            className="inline-block bg-accent1 text-white font-bold text-lg py-3 px-6 rounded-lg shadow-lg hover:bg-white hover:text-primary transform transition-transform duration-300 hover:scale-105"
          >
            Explore Our Services
          </a>

          {/* Icon Animation */}
          <div className="flex justify-center mt-12 relative h-24">
            <i className="fas fa-lightbulb text-white text-6xl mb-4 mr-4 absolute animate-icon"></i>
            <i className="fas fa-cogs text-white text-6xl mb-4 mr-4 absolute animate-icon"></i>
            <i className="fas fa-headset text-white text-6xl mb-4 mr-4 absolute animate-icon"></i>
          </div>
        </div>
      </div>

      {/* CSS Animations */}
      <style jsx>{`
        @keyframes fadeInOut {
          0% {
            opacity: 0;
          }
          10% {
            opacity: 1;
          }
          30% {
            opacity: 1;
          }
          40% {
            opacity: 0;
          }
          100% {
            opacity: 0;
          }
        }

        @keyframes slideUp {
          0% {
            transform: translateY(50px);
            opacity: 0;
          }
          100% {
            transform: translateY(0);
            opacity: 1;
          }
        }

        .animate-icon {
          position: absolute;
          opacity: 0;
          animation: fadeInOut 9s infinite;
        }

        .animate-icon:nth-child(1) {
          animation-delay: 0s;
        }

        .animate-icon:nth-child(2) {
          animation-delay: 3s;
        }

        .animate-icon:nth-child(3) {
          animation-delay: 6s;
        }

        .animate-slide-up {
          animation: slideUp 2s ease-out forwards;
        }
      `}</style>
    </section>
  );
};

export default Hero;
